import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[maxNumber]"
})
export class MaxNumberDirective {
  @Input() maxNumber: number;

  constructor(private el: ElementRef) {
  }

  @HostListener("blur", ["$event"]) onBlur(event) {
    const inputAsNumber = parseInt(this.el.nativeElement.values, 10) || parseFloat(this.el.nativeElement.values) || null;
    if (!Number.isNaN(inputAsNumber) && this.maxNumber) {
      if (inputAsNumber > this.maxNumber) {
        this.el.nativeElement.values = this.maxNumber;
      }
    }
  }
}
